import React from 'react';
import { useParams, NavLink } from 'react-router-dom';

import { Breadcrumb } from '@shared/components/bootstrap';

import { accountsURL, accountURL, thirdPartyTransferDetailsURL } from '@admin/config/routes';
import { ThirdPartyTransfer, useThirdPartyTransferContextQuery } from '@admin/schema';

export const Breadcrumbs: React.FC<{
  thirdPartyTransfer?: Pick<ThirdPartyTransfer, 'id' | 'bookingPlatform' | 'bookingNumber'>;
  editing?: boolean;
}> = ({ thirdPartyTransfer, editing }) => {
  const { accountID } = useParams<{ accountID: string }>();
  const { data } = useThirdPartyTransferContextQuery({ variables: { accountID: accountID } });

  if (!data) return null;

  return (
    <Breadcrumb>
      <Breadcrumb.Item>
        <NavLink to={accountsURL()} className="text-primary">
          Accounts
        </NavLink>
      </Breadcrumb.Item>
      <Breadcrumb.Item>
        <NavLink to={accountURL({ id: accountID })} className="text-primary">
          {data.account.customer.name}
        </NavLink>
      </Breadcrumb.Item>
      {thirdPartyTransfer ? (
        <>
          <Breadcrumb.Item>
            <NavLink to={thirdPartyTransferDetailsURL(accountID, thirdPartyTransfer.id)} className="text-primary">
              Third-Party Transfer ({thirdPartyTransfer.bookingPlatform} | {thirdPartyTransfer.bookingNumber})
            </NavLink>
          </Breadcrumb.Item>
          {editing && <Breadcrumb.Item active>Edit</Breadcrumb.Item>}
        </>
      ) : (
        <Breadcrumb.Item active>Create Third-Party Transfer</Breadcrumb.Item>
      )}
    </Breadcrumb>
  );
};
